import type { SkillLabel } from '@revelio/data-access';

import type { SpecificCustomSkill } from '../../../../../../shared/selection-lists/hooks/useSpecificCustomSkills';

export const CUSTOM_SKILL_REPORT_LIST_KEY = 'custom_skill';
const CUSTOM_SKILL_LIST_PREFIX = 'custom_skill_k';

export const skillLevelToListName = (level: SpecificCustomSkill): string => {
  const match = level.label.tag.match(/_k(\d+)$/i);
  if (!match) return '';
  const kValue = Number(match[1]);
  return CUSTOM_SKILL_LIST_PREFIX + kValue;
};

export const filterToSupportedLevels = (levels: SkillLabel[]) => {
  const isWithinKRange = (tag: string): boolean => {
    const match = tag.match(/_k(\d+)$/i);
    if (!match) return false;
    const kValue = Number(match[1]);
    return kValue >= 150 && kValue <= 10000;
  };
  return levels.filter((l) => isWithinKRange(l.tag));
};

export const combineCustomSkillValues = (
  entities: { type: string; values: string[]; id?: string }[]
) => {
  const customSkillValues: string[] = [];
  let customSkillId: string | undefined;

  entities.forEach((entity) => {
    if (entity.type.startsWith(CUSTOM_SKILL_LIST_PREFIX)) {
      if (!customSkillId && entity.id) {
        customSkillId = entity.id;
      }
      const kValue = entity.type.replace(CUSTOM_SKILL_LIST_PREFIX, '');
      entity.values.forEach((value) => {
        customSkillValues.push(`k${kValue}_${value}`);
      });
    }
  });
  return (() => {
    if (customSkillValues.length > 0) {
      return [
        ...entities,
        {
          type: CUSTOM_SKILL_REPORT_LIST_KEY,
          values: customSkillValues,
          id: customSkillId,
        },
      ];
    }
    return entities;
  })().filter((entity) => !entity.type.startsWith(CUSTOM_SKILL_LIST_PREFIX));
};
